module.exports = __webpack_public_path__ + "static/img/16.dfa8a62.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/sp/16.png
// module id = vonM
// module chunks = 0